/* Spacing mirrors the prototype's `.fg` / `.fl` so field rhythm matches. */
.group {
  margin-bottom: 13px;
}
.label {
  display: block;
  margin-bottom: 5px;
  color: var(--sage);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.hint {
  margin-top: var(--sp-1);
  color: var(--text2);
  font-size: 10.5px;
  line-height: 1.5;
}
.error {
  margin-top: var(--sp-1);
  color: var(--magenta);
  font-size: 10.5px;
  font-weight: 500;
}
.required {
  margin-left: 3px;
  color: var(--magenta);
}

.control {
  width: 100%;
  padding: 8px 11px;
  border: 1px solid var(--line2);
  border-radius: 7px;
  background: var(--bg2);
  color: var(--text);
  font-size: 12px;
  transition: var(--transition);
}
.control:focus {
  border-color: var(--magenta);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--magenta) 12%, transparent);
  outline: none;
}
.control:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.invalid {
  border-color: var(--magenta);
}

textarea.control {
  min-height: 72px;
  resize: vertical;
  font-family: inherit;
}

/*
 * Inline table-cell editing. The min-width stops a dense table from squeezing
 * a field down to a few clipped characters; the table scrolls instead.
 */
.inline {
  width: 100%;
  min-width: 80px;
  padding: 5px 7px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--text);
  font-family: inherit;
  font-size: 11.5px;
}
.inline:hover:not(:disabled) {
  border-color: var(--line2);
}
.inline:focus {
  border-color: var(--magenta);
  background: var(--bg2);
  outline: none;
}
.inline:disabled {
  cursor: default;
}
